var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container pl-20 pr-20 pt-10 " },
    [
      _c(
        "div",
        { staticClass: "row pl-3 pr-3" },
        [
          _vm.canSubscribeThirdParties
            ? _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Suscribir a un usuario",
                      expression: "'Suscribir a un usuario'"
                    }
                  ],
                  staticClass: "mr-3 btn-icon fb-bg-primary",
                  class: {
                    "cursor-not-allowed": _vm.userPermissions.totalControl === 0
                  },
                  attrs: {
                    variant: "primary",
                    disabled: _vm.userPermissions.totalControl === 0,
                    "data-cy": "subscribe-a-user"
                  },
                  on: { click: _vm.newSubscription }
                },
                [_c("feather-icon", { attrs: { icon: "UsersIcon" } })],
                1
              )
            : _vm._e(),
          !_vm.disabledSelfSubscription
            ? _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Suscribirme",
                      expression: "'Suscribirme'"
                    }
                  ],
                  staticClass: "mr-3 btn-icon fb-bg-primary",
                  attrs: {
                    icon: "UserIcon",
                    variant: "primary",
                    "data-cy": "subscribe"
                  },
                  on: { click: _vm.selfSubscription }
                },
                [_c("feather-icon", { attrs: { icon: "UserIcon" } })],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row justify-content-center mt-8" },
        [
          _c(
            "app-timeline",
            { staticClass: "mb-24" },
            _vm._l(_vm.subscribersList, function(subscriber, index) {
              return _c(
                "app-timeline-item",
                {
                  key: subscriber.suscripcionId,
                  attrs: { variant: "secondary" }
                },
                [
                  _c(
                    "b-media",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.loading,
                          expression: "!loading"
                        }
                      ],
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "aside",
                            fn: function() {
                              return [
                                _c("b-avatar", {
                                  attrs: { src: _vm.getAvatar() }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-sm-row flex-column\n            flex-wrap justify-content-between mb-1 mb-sm-0"
                        },
                        [
                          _c("h6", [_vm._v(_vm._s(subscriber.nombre))]),
                          _vm.userPermissions.totalControl === 1 ||
                          _vm.currentUser.id === subscriber.usuarioSuscrito
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Eliminar suscripción",
                                    expression: "'Eliminar suscripción'"
                                  }
                                ],
                                staticClass: "text-danger cursor-pointer",
                                attrs: {
                                  icon: "Trash2Icon",
                                  size: "16",
                                  "data-cy": "eliminate-subscription"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeSubscription(index)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      subscriber.suscripcionHasta
                        ? _c("span", [
                            _vm._v(
                              " Suscrito desde " +
                                _vm._s(
                                  _vm
                                    .$moment(
                                      subscriber.suscripcionDesde,
                                      "YYYY-MM-DD"
                                    )
                                    .format("DD-MM-YYYY")
                                ) +
                                " hasta " +
                                _vm._s(
                                  _vm
                                    .$moment(
                                      subscriber.suscripcionHasta,
                                      "YYYY-MM-DD"
                                    )
                                    .format("DD-MM-YYYY")
                                ) +
                                " "
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              " Suscrito desde " +
                                _vm._s(
                                  _vm
                                    .$moment(subscriber.suscripcionDesde)
                                    .format("DD-MM-YYYY")
                                ) +
                                " "
                            )
                          ])
                    ]
                  ),
                  _c(
                    "b-media",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "aside",
                            fn: function() {
                              return [
                                _c("b-skeleton", {
                                  attrs: { type: "avatar", animation: "fade" }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-sm-row flex-column\n            flex-wrap justify-content-between mb-1 mb-sm-0"
                        },
                        [
                          _c("b-skeleton", { staticClass: "w-32" }),
                          _c("b-skeleton", { staticClass: "w-5" })
                        ],
                        1
                      ),
                      _c("p", [_c("b-skeleton", { staticClass: "w-64" })], 1)
                    ]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      !_vm.subscribersList.length
        ? _c("div", [
            _c("h5", { staticClass: "mt-3 text-center" }, [
              _vm._v("No hay suscripciones para este elemento")
            ])
          ])
        : _vm._e(),
      _c("SubscriptionForm", {
        attrs: { isSelfSubscription: _vm.isSelfSubscription }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }